<template lang="pug">
  .sample-cv(v-if="cv.personal")
    .section
      .container.little
        router-link.back(:to="{name: 'MyCVS', params: {lang: getLanguage}, query: {page: $route.params.prev}} " ) <&#160; {{ gettext('Back to CV') }}
        .tile.is-ancestor
          .tile.is-parent.is-12
            h2 {{ gettext('Jobseeker’s profile') }}
            .content.content-profile.white-fone
              .grid.bordered-bottom
                div.grid-children
                  div.block.m-b-1.one-col(v-if="cv.personal.last_name")
                    .title {{ cv.personal.first_name }}
                    .title {{ cv.personal.last_name }}
                      router-link.back.edit(:to="{name: 'EditCV', params: {lang: getLanguage, id: $route.params.id}}")
                        .mdi.mdi-square-edit-outline
                  .cv-id.one-col
                    p cv id: {{ $route.params.id }}
                  div.block(v-if="cv.public.profession_company_type")
                    p.type {{ gettext('Considering industry') }}
                  div.block(v-if="cv.public.profession_company_type")
                    p
                      | {{(cv.public.profession_company_type || {}).name}}

                  div.block(v-if="cv.public.profession_company_sector")
                    p.type {{ gettext('Considering sector') }}
                  div.block(v-if="cv.public.profession_company_sector")
                    p
                      | {{(cv.public.profession_company_sector || {}).name}}

                  div.block
                    p.type {{ gettext('Profession') }}
                  div.block(v-if="cv.public.profession")
                    p {{ (cv.public.profession || {}).name }}
                  div.block(v-else)
                    p {{ gettext('Do not have profession yet') }}
                  div.block(v-if="cv.personal.birth_date")
                    p.type {{ gettext('Age') }}
                  div.block(v-if="cv.personal.birth_date")
                    p {{ cv.personal.birth_date | age }}
                  div.block(v-if="cv.personal.height")
                    p.type {{ gettext('Height')  }} (cm)
                  div.block(v-if="cv.personal.height")
                    p {{ cv.personal.height }}
                  div.block(v-if="cv.personal.weight")
                    p.type {{ gettext('Weight') }} (kg)
                  div.block(v-if="cv.personal.weight")
                    p {{ cv.personal.weight }}
                  div.block
                    p.type {{ gettext('EU Citizenship') }}
                  div.block
                    p {{ cv.personal.eu_citizenship ? 'Yes' : 'No'}}
                div.ordered-1
                  .img-wrap(v-if="cv.personal.image_urls")
                    img(:src="cv.personal.image_urls.main")

              p.type-thin.top-space {{ gettext('Contact information') }}
              .grid.bordered-bottom.contact-information

                div.grid-children
                  p.type {{ gettext('Phone') }}
                  p {{ cv.personal.phone}}
                  p.type {{ gettext('Email') }}
                  p {{ cv.personal.email }}
                  p.type {{ gettext('Skype') }}
                  p {{ cv.personal.skype || '-' }}
                  p.type {{ gettext('Facebook') }}
                  p {{ cv.personal.facebook || '-' }}
                  p.type {{ gettext('Linkedin') }}
                  p {{ cv.personal.linkedin || '-' }}

              p.type-thin.top-space {{ gettext('Location of residence') }}
              .grid.bordered-bottom.contact-information

                div.grid-children
                  p.type {{ gettext('Country of residence') }}
                  p {{ (cv.public.location_country || {}).name }}
                  p.type {{ gettext('City of residence') }}
                  p {{ cv.public.location_city }}
                  p.type {{ gettext('Staying type') }}
                  p {{ (cv.public.location_staying_type || {}).name }}

              p.type-thin.top-space(v-if="(cv.public.work_experiences || []).length") {{ gettext('Work experience:') }}
              .grid.experience-block(
                v-for="(experience, index) in cv.public.work_experiences"
                :class="{'bordered-bottom': index === cv.public.work_experiences.length - 1}"
              )
                div.grid-children
                  p.type {{ gettext('Work period') }}
                  p {{ gettext('from') }} &nbsp;
                    b {{ experience.period_from | dateFormat }} &nbsp;
                    | {{ gettext('to') }} &nbsp;
                    b(v-if="experience.period_to") {{ experience.period_to | dateFormat }}
                    b(v-else) {{ gettext('Present') }}
                  p.type(v-if="experience.company") {{ gettext('Company') }}
                  p(v-if="experience.company") {{ experience.company }}
                  p.type {{ gettext('Country') }}
                  p {{ experience.country.name }}
                  p.type {{ gettext('Company types') }}
                  p {{ experience.company_type.name }}
                  p.type {{ gettext('Company sector') }}
                  p {{ experience.company_sector.name }}
                  p.type(v-if="!experience.profession") {{ gettext('Position') }}
                  p.type(v-else) {{ gettext('Profession') }}
                  p(v-if="!experience.profession") {{ experience.position }}
                  p(v-else) {{ experience.profession.name }}
                p.type-thin.description(v-if="experience.responsibilities") {{ gettext('Responsibility') }}
                p.description(v-if="experience.responsibilities")
                  pre {{ experience.responsibilities }}

              p.type-thin.top-space {{ gettext('Education:') }}
              .grid.educations-block(
                v-for="(education, index) in cv.public.educations"
                :class="{'bordered-bottom': index === cv.public.educations.length - 1}"
              )
                div.grid-children
                  p.type {{ gettext('Type of education') }}
                  p {{ education.education_type.name }}
                  p.type {{ gettext('Education status') }}
                  p {{ education.education_status.name }}
                  p.type {{ gettext('Educational institution') }}
                  p {{ education.institution }}
                  p.type {{ gettext('Faculty, specialty') }}
                  p {{ education.faculty || '-' }}
                  p.type {{ gettext('Country') }}
                  p {{ education.country.name }}
                  p.type(v-if="education.period_from && education.period_to") {{ gettext('Period') }}
                  p(v-if="education.period_from && education.period_to") {{ gettext('from') }} &nbsp;
                    b {{ education.period_from | dateFormat }} &nbsp;
                    | {{ gettext('to') }} &nbsp;
                    b {{ education.period_to | dateFormat }}
                p.type-thin.description(v-if="education.description") {{ gettext('Description') }}
                p.description(v-if="education.description")
                  pre {{ education.description }}

              p.type-thin.top-space {{ gettext('Languages:')}}
              .grid.languages-block(
                v-for="(language, index) in cv.public.languages"
                :class="{'bordered-bottom': index === cv.public.languages.length - 1}"
              )
                div.grid-children
                  p.type {{gettext('Language') }}
                  p {{ language.language.name }}
                  p.type {{ gettext('Level') }}
                  p {{ language.level.name }}

              p.type-thin.top-space(v-if="(cv.public.driving_licences || []).length") {{ gettext('Driver\'s licence') }}
              .driving-licences(v-if="(cv.public.driving_licences || []).length")
                div(v-for="licence in cv.public.driving_licences")
                  span.tag.is-success {{ licence.name }}

              p.type-thin.top-space(v-if="cv.personal.about") {{ gettext('About yourself') }}
              .field.description(v-if="cv.personal.about")
                pre {{ cv.personal.about }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { gettext, ngettext } from '@/services/TranslateHandler'
import mixin from '@/mixins'
const toastr = require('toastr')

const moment = require('moment')
const _ = require('lodash')

export default {
  name: 'ViewCV',
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo})
  },
  data () {
    return {
      cv: {
        personal: {},
        public: {}
      }
    }
  },
  methods: {
    gettext: gettext,
    ngettext: ngettext,
    ...mapActions([
      'jobseekerGetCV',
      'getPublicCV',
      'receiveCountries',
      'receiveCompanyTypes'
    ]),
    getName (id, name) {
      let result = _.find(this.$data[name], {'id': id})
      if (result) return result.name
    },
    getData () {
      this.getPublicCV({lang: this.getLanguage, id: parseInt(this.$route.params.id)}).then(res => {
        this.cv.public = res
      }).catch(() => {
        toastr.error(gettext('Server error!'), gettext('Error!'))
      })
      this.jobseekerGetCV(parseInt(this.$route.params.id)).then(res => {
        this.cv.personal = res.cv
      }).catch(() => {
        toastr.error(gettext('Server error!'), gettext('Error!'))
      })
    }
  },
  filters: {
    sliceName: function (name) {
      return `${name.charAt(0)}. `
    },
    age: function (date) {
      let formatted = (moment()).diff(moment(date), 'years')
      return `${formatted} ${ngettext('year', 'years', formatted)} (${moment(date).format('MMMM DD, YYYY')})`
    },
    dateFormat: function (date) {
      return `${moment(date).format('DD/MM/YYYY')}`
    }
  },
  created () {
    if (this.$route.params.id) {
      this.getData()
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Bixter | ' + gettext('My CV'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    }
  }
}
</script>

<style lang='scss' src='./styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/profile/cvs/cv-view/index.vue